import firebase from 'firebase/app'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyBg42MIe9bt7e8BQiifuBEQPr9ojCKPECw",
    authDomain: "keypoll-6b6d8.firebaseapp.com",
    databaseURL: "https://keypoll-6b6d8.firebaseio.com",
    projectId: "keypoll-6b6d8",
    storageBucket: "keypoll-6b6d8.appspot.com",
    messagingSenderId: "848206306677"
};
// // The Cloud Functions for Firebase SDK to create Cloud Functions and setup triggers.
// const functions = require('firebase-functions');

// // The Firebase Admin SDK to access Cloud Firestore.
// const admin = require('firebase-admin');
// admin.initializeApp();

firebase.initializeApp(config);